import React from 'react';
import ProductText from '../../molecules/product-text';

const ProductTextCMS = (props) => props.data?.products
&& (
  <ProductText products={props.data.products} />
);

ProductTextCMS.whyDidYouRender = true;

export default ProductTextCMS;
